import React from 'react';
import Pawfectlogo from "../images/Pawfectlogo.png";
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer id="footer" className="footer bg-[#372E2F] text-white py-4 px-6 text-opacity-75">
            <div className="footer-container mx-auto max-w-screen-xl flex flex-col md:flex-row gap-10 items-center md:items-start justify-center md:justify-between">
                {/* Logo Section */}
                <div className="footer-logo flex flex-col items-center md:items-start mb-6 md:mb-0">
                    <img src={Pawfectlogo} alt="Pawfect logo" className="logo w-32 h-11 object-cover shadow-lg"/>
                    <div className="description mt-4 text-sm text-center md:text-left space-y-1">
                        <p className="mb-0">Paws, meet your perfect</p>
                        <p className="mb-0">match! The premier dog</p>
                        <p className="mb-0">social app.</p>
                    </div>
                </div>

                {/* Text Section */}
                <div className="footer-text flex flex-col items-center md:items-start text-center md:text-left mb-6 md:mb-0">
                    <div className="links space-y-2">
                        <Link to="/pawfect-privacy-policy" target="_blank" rel="noopener noreferrer" className="link text-sm underline block">
                            Privacy Policy
                        </Link>
                        <Link to="/pawfect-terms-and-conditions" target="_blank" rel="noopener noreferrer" className="link text-sm underline block">
                            Terms & Conditions
                        </Link>
                        <Link to="/pawfect-end-user-license-aggrement" target="_blank" rel="noopener noreferrer" className="link text-sm underline block" >
                            End User License Agreement
                        </Link>
                        <Link to="/pawfect-interaction-agreement" target="_blank" rel="noopener noreferrer" className="link text-sm underline block" >
                            Pawfect Interaction Agreement
                        </Link>
                        <Link to="/pawfect-disclaimer" target="_blank" rel="noopener noreferrer" className="link text-sm underline block" >
                            Disclaimer
                        </Link>
                    </div>
                </div>

                {/* Contact Section */}
                <div className="footer-contact flex flex-col items-center md:items-start text-center md:text-left mb-6 md:mb-0">
                    <p className="contact-title text-lg font-semibold mb-2">Contact</p>
                    <a href="tel:+91 6357023470" className="link text-sm">
                        Phone: +91 6357023470
                    </a>
                    <p className="email text-sm mb-2">
                        Email: <a href="mailto:info@pawfect.co.in" className="link underline">info@pawfect.co.in</a>
                    </p>
                </div>

                {/* Address Section */}
                <div className="footer-address flex flex-col items-center md:items-start text-center md:text-left">
                    <p className="address-title text-lg font-semibold mb-2">Address</p>
                    <p className="address text-sm font-bold mb-1">STALLION ENTERPRISE</p>
                    <p className="address text-sm">
                        Survey No. 220, C\O. Gallops Bmw Showroom,<br />
                        Nr. Amin Jcb Equipment, Nr.Sarkhej \ Sanand Cross Road,<br />
                        Ahmedabad, Gujarat, 382210 ,India
                    </p>
                </div>
            </div>

            <div className="footer-bottom text-center text-sm mt-4 border-t border-gray-700 pt-4 mb-0">
                © {new Date().getFullYear()} Pawfect. All rights reserved
            </div>
        </footer>

    );
};

export default Footer;
